import React from 'react';
import {connect} from "react-redux";
import autobind from 'autobind-decorator';
import {Route, Router, Switch} from 'react-router-dom'
import {DragDropContext} from 'react-beautiful-dnd';
import './icons';

import {service as ConservationActionTypeService} from "./Services/ConservationActionTypeService";
import {service as OrganizationService} from "./Services/OrganizationService";

import {
	HistoryUtils
} from "./Utils/HistoryUtils";
import {
	StreamBankErrorDisplayEnhance,
} from "./Components/Common/Enhancements/StreamBankErrorDisplayEnhance";
import {    
    StreamBankLoaderIconDisplayEnhance
} from "./Components/Common/Enhancements/StreamBankLoaderIconDisplayEnhance";
import {    
    StreamBankSessionTimeoutCheckerEnhance,
} from "./Components/Common/Enhancements/StreamBankSessionTimeoutCheckerEnhance";

import {StreamBankToolRouter} from "./Components/Common/StreamBankToolRouter";

import {LoginPage} from './Components/Pages/Login/LoginPage';
import {ForgotPasswordPage} from './Components/Pages/Login/ForgotPasswordPage';

import {ContactsViewPage} from './Components/Pages/Contacts/ViewPage';
import {UsersViewPage} from './Components/Pages/Users/ViewPage';
import {UsersSubscriptionsPage} from './Components/Pages/Users/SubscriptionsPage';
import {SurveysViewPage} from './Components/Pages/Surveys/ViewPage';
import {UsersIndexPage} from './Components/Pages/Users/IndexPage';
import {SurveysIndexPage} from './Components/Pages/Surveys/IndexPage';
import {CustomListIndexPage} from './Components/Pages/SpeciesLists/CustomLists/CustomListIndexPage';
import {CustomListViewPage} from './Components/Pages/SpeciesLists/CustomLists/CustomListViewPage';
import {GlobalSpeciesPage} from './Components/Pages/SpeciesLists/GlobalList/GlobalSpeciesPage';
import {SecureDownloadPage} from './Components/Pages/SecureDownload/Page';
import {QueryToolIndexPage} from './Components/Pages/QueryTool/IndexPage';
import {ServiceDrivenViewPage} from "./Components/Common/ServiceDrivenViewPage";
import {ServiceDrivenIndexPage} from "./Components/Common/ServiceDrivenIndexPage";
import {SpeciesRequestsPage} from "./Components/Pages/SpeciesLists/SpeciesRequests/SpeciesRequestsPage";

import {LibraryRedirectPage} from "./Components/Pages/Library/LibraryRedirectPage";

import {Header} from "./Components/Layout";
import {Footer} from "./Components/Layout";

import {SET_DRAG_DROP} from "./Redux/Actions/Types";
import {LogoutPage} from "./Components/Pages/Login/LogoutPage";
import {ReportBuilderIndexPage} from "./Components/Pages/ReportBuilder/IndexPage";

@StreamBankSessionTimeoutCheckerEnhance
@StreamBankErrorDisplayEnhance
@StreamBankLoaderIconDisplayEnhance
class _StreamBankApp extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            error: null,
        };
    }

    @autobind
    onDragStart() {}

    @autobind
    onDragUpdate() {}

    @autobind
    onDragEnd(result) {
        this.props.setDragDrop(result);
    }

    render() {
        const { error } = this?.state || {};

        if(error) {
            //TODO: Setup a better error page.
            return <span>
                An unrecoverable error has occurred. Please refresh the page and try again.
            </span>;
        }

        return <DragDropContext
            onDragStart={this.onDragStart}
            onDragUpdate={this.onDragUpdate}
            onDragEnd={this.onDragEnd}
        >
            <Header />
            <Router history={HistoryUtils.GetHistory()}>
                <Switch>
                    <Route path="/" exact component={ StreamBankToolRouter } />
                    <Route path="/login" component={ LoginPage } />
                    <Route path="/logout" component={ LogoutPage } />
                    <Route path="/forgotPassword" component={ ForgotPasswordPage } />
                    <Route path="/files/download/:fileId/:fileName?" component={SecureDownloadPage} />


                    <Route path="/users/subscriptions"
                        component={ UsersSubscriptionsPage }
                    />
                    <Route path="/users/:userId"
                        component={ UsersViewPage }
                    />
                    <Route path="/organizations/:organizationId"
                        component={ ServiceDrivenViewPage(OrganizationService) }
                    />
                    <Route path="/surveys/:surveyId"
                        component={ SurveysViewPage }
                    />
                    <Route path="/users"
                        component={ UsersIndexPage }
                    />
                    <Route path="/organizations"
                        component={ ServiceDrivenIndexPage(OrganizationService) }
                    />
                    <Route path="/surveys"
                        component={ SurveysIndexPage }
                    />
                    <Route path="/speciesLists/:speciesListId"
                        component={ CustomListViewPage }
                    />
                    <Route path="/speciesLists"
                        component={ CustomListIndexPage }
                    />
                    <Route path="/allSpecies"
                        component={ GlobalSpeciesPage }
                    />
                    <Route path="/speciesRequests"
                        component={ SpeciesRequestsPage }
                    />
                    <Route path="/query"
                           component={ QueryToolIndexPage }
                    />
                    <Route path="/reportBuilder"
                           component={ ReportBuilderIndexPage }
                    />
                    <Route path="/conservationActionTypes/:conservationActionTypeId"
                           component={ ServiceDrivenViewPage(ConservationActionTypeService) }
                    />
                    <Route path="/conservationActionTypes"
                           component={ ServiceDrivenIndexPage(ConservationActionTypeService) }
                    />
                    <Route path="/library"
                           component={ LibraryRedirectPage }
                    />

                    {/* TODO: This is a hacky that these tools have to be redefined, but yeah, we cant have two /wildcard/wildcard routes :/ */}
                    {/* Let's consider how we can make the Contacts page a tool in the ToolRouter? */ }
                    <Route path="/:pProgId/:cProgId/:projId/contacts/:conId"
                        component={ ContactsViewPage }
                    />
                    <Route path="/:pProgId/:cProgId/contacts/:conId"
                        component={ ContactsViewPage }
                    />
                    <Route path="/:pProgId/contacts/:conId"
                        component={ ContactsViewPage }
                    />
                    <Route path="/contacts/:conId"
                        component={ ContactsViewPage }
                    />

                    <Route path="/:pProgId/:cProgId/:projId/:conActId/:sampleEventId/:tool"
                        component={ StreamBankToolRouter }
                    />
                    <Route path="/:pProgId/:cProgId/:projId/:conActId/:tool"
                        component={ StreamBankToolRouter }
                    />
                    <Route path="/:pProgId/:cProgId/:projId/:tool"
                        component={ StreamBankToolRouter }
                    />
                    <Route path="/:pProgId/:cProgId/:tool"
                        component={ StreamBankToolRouter }
                    />
                    <Route path="/:pProgId/:tool"
                        component={ StreamBankToolRouter }
                    />

                    <Route path="/:tool"
                        component={ StreamBankToolRouter }
                    />
                </Switch>
            </Router>
            <Footer />
        </DragDropContext>;
    }
}

const mapDispatchToProps = dispatch => ({
    setDragDrop: result => {
        dispatch({type: SET_DRAG_DROP, result});
    }
});

export const StreamBankApp = connect(null, mapDispatchToProps)(_StreamBankApp);
